export default {
  en: {
    dashboard: {
      dazzle: {
        addRow: 'Add row',
        removeRow: 'Remove row',
        confirmDeleteRow: {
          header: 'Row will be deleted',
          subHeader: 'Do you really want to delete row?',
          btnConfirm: 'Delete',
          btnSecondaryConfirm: 'Cancel',
        },
        verticalOrientation: 'Vertical orientation',
        horizontalOrientation: 'Horizontal orientation',
        addNewWidget: 'Add Widget',
        removeWidget: 'Remove',
        editWidget: 'Edit',
        untitled: 'Untitled',
      },
      summaryTableStates: {
        success: 'OK',
        info: 'INFO',
        warning: 'WARNING',
        danger: 'CRITICAL',
      },
      validation: {
        required: 'Required',
        requiredName: 'Please set widget title',
        groupAlreadyExists: 'Title already exists',
        selectLayoutOption: 'Select layout option',
        requiredReports:
          "You have to assign at least one table's colorizing rule",
        requiredOptions: 'Select options',
        positiveWeight: 'Weight must be positive number',
      },
      heading: 'Dashboard',
      titlePlaceholder: 'Title',
      labels: {
        ok: 'OK',
        info: 'Info',
        warning: 'Warning',
        critical: 'Critical',
        remaining: 'No results',
      },
      networkVendorMix: 'Network vendor mix',
      hostVendorMix: 'Host vendor mix',
      scoreLabels: {
        ok: 'No impact',
        info: 'Low impact',
        warning: 'Medium impact',
        critical: 'High impact',
        remaining: 'No results',
      },
      widgets: {
        textRow: 'Discovery Data',
        networkVendorMix: 'Networking Hardware Vendors',
        hostVendorMix: 'Host Vendors',
        tableColor: 'Intent Verifications',
        deviceChart: {
          title: 'Device Change',
          axeTotal: 'Discovered Devices',
          axeChanges: 'Number of Changes',
          deviceAddedCount: 'Added devices',
          deviceRemovedCount: 'Removed devices',
          deviceTotalCount: 'Total devices',
        },
      },
      editBar: {
        btnEdit: 'Edit',
        btnSave: 'Save',
      },
      dialog: {
        widgetsDescription: {
          TextRow: 'General statistics of the last discovery data',
          NetworkVendorMix:
            'Chart of vendors that produce the discovered network hardware',
          HostVendorMix: 'Chart of vendors that produce the end user hardware',
          TableColor: 'Visualize network intent verification results',
          DeviceChart: 'Vizualize device change per snapshot',
        },
        title: 'Select Widget',
        editTitle: 'Edit widget',
        addRowTitle: 'Add Row',
        btnClose: 'Close',
        btnBack: 'Back',
        btnAdd: 'Add',
        btnSelect: 'Select',
        btnCreate: 'Create',
        btnSave: 'Save',
        btnUpdate: 'Update',
        selectType: 'Select type',
        selectLayout: 'Select layout',
        group: 'Group',
        type: 'Type',
        column: 'Column',
        placement: 'Placement',
        displayType: 'Display type',
        groupSummary: {
          colorRule: 'Color rule',
          path: 'Path',
          weight: 'Weight',
          searchPlaceholder: 'Search in rule names',
          editGroups: 'Edit Title',
          dropHelp: 'Assign intent verification rules from the right side.',
          dropHelp2: 'Use double click or drag & drop to insert / remove',
          dropColorRule: 'Use drag & drop to assign ',
          groupSettings: 'Group Settings',
          selectWidgetView: 'Select Widget View',
          tableColorsRules: 'Intent Verification Rules',
          noRuleFound: 'Nothing found',
          noRuleDefined: 'No intent verification rules defined',
          widgetTitle: 'Widget Title',
          noReportsGroups: 'No groups available. Create new group.',
          newGroup: 'New Title',
          editGroup: 'Edit Title',
          groupName: 'Group Name',
          inAbsolute: 'In absolute',
          confirmDeleteGroup: {
            title: 'Are you sure you want to delete the widget?',
            btnConfirm: 'Delete',
            btnCancel: 'Cancel',
          },
          table: 'Table',
          stackedBarChart: 'Stacked bar chart',
          graphPie: 'Pie chart',
          addOrEditGroup: 'Add or edit groups',
          addGroup: 'Add group',
          selectTitle: 'Select title',
          title: 'Title',
          noReportsAddReports:
            'Add report by dragging or selecting from reports.',
          newGroupIcon: 'New group',
          editGroupIcon: 'Edit group',
          deleteGroupIcon: 'Delete group',
          newGroupLabel: 'New group',
          editGroupLabel: 'Group name',
          addView: 'Add view',
          updateView: 'Update view',
        },
        colorFilter: {
          valueType: 'Value type',
          valueTypeOptions: {
            relative: 'Relative',
            absolute: 'Absolute',
          },
        },
        textRow: {
          name: 'Name',
          noVariablesAvailable: 'No variables available',
          search: 'Search',
        },
        addRow: {
          x: 'Add one-column layout',
          xx: 'Add two-column layout',
          xxx: 'Add three-column layout',
        },
      },
      textRowVariables: {
        networkDevicesDiscovered: 'Network devices discovered',
        networkInterfacesActivetotal: 'Network interfaces active / total',
        numberOfHost: 'Number of hosts',
        interfaceEdgeCount: 'Number of edge interfaces',
      },
      groupSummary: {
        count: 'Count',
        report: 'Report',
        status: 'Status',
        noResultsAvailable: 'No results available',
        noResults: 'No results',
        weight: 'Weight',
        remove: 'Remove',
        groupNotFound: 'Invalid Widget',
      },
      noDataAvailable: 'No data available',
      noReportAvailable: 'Reports not available',
      reportError: 'Report error',
      leaveDialogue: {
        header: 'Dashboard is not saved',
        subHeader: 'Do you really want to leave form without save?',
        btnSave: 'Save changes & Leave',
        btnLeave: 'Leave',
      },
    },
    overview: {
      noDataAvailableTitle: 'No Data Available',
      noDataAvailableWhileRunning: 'Network discovery process is running',
      noDataAvailableDueError: 'Please rerun the discovery process',
    },
  },
};
